/**
 * The relative branch rejects anything that turns a leading `/` into an authority: a second
 * slash, a backslash (clients normalise `\` to `/`), or either percent-encoded. Each resolves
 * off-site, making an authored link an open redirect. PolyContentService's
 * `RedirectRuleValidator.validateDestinationUrl` refuses the same four.
 */
const NAVIGABLE_URL = /^(https?:\/\/|\/(?![/\\]|%2f|%5c)|#|mailto:)/i;

/** Removed before a URL resolves, so `/⇥/host` would pass as relative then resolve as `//host`. */
const STRIPPED_BEFORE_RESOLUTION = /[\t\n\r]/g;

/**
 * Whether an authored `href` is safe to render as a link destination. Shared by every component
 * that renders one: a per-component copy drifts, and the more permissive one silently reopens a
 * bypass its sibling already closed.
 *
 * @param href - Authored URL, or `undefined` when the field was left blank.
 * @returns `true` when the URL may be placed on a rendered anchor.
 */
export const isNavigableUrl = (href?: string): boolean =>
  NAVIGABLE_URL.test(href?.replace(STRIPPED_BEFORE_RESOLUTION, '').trim() ?? '');
